import { z } from 'zod';

export const publicProfileSchema = z.object({
    user_id: z.string().uuid(),
    link_keys: z.array(z.string()),
    name: z.string(),
    looking_for: z.string(),
    budget_max: z.number(),
    preferred_areas: z.array(z.string()),
    apartment_size_min: z.number().min(10).nullable().catch(null),
    rooms_min: z.number().min(1).catch(1),
    move_in_date: z.string().min(1).nullable().catch(null),
    min_contract_months: z.number().min(1).nullable().catch(null),
    about_me: z.string().min(1).nullable().catch(null),
    soft_factors: z.string().nullable().catch(null),
    profile_image_url: z.string().nullable().catch(null),
    documents_available: z.array(z.string()),
    is_published: z.boolean().default(false),
    created_at: z.string(),
    updated_at: z.string(),
    job: z.string().nullable().catch(null),
    age: z.number().nullable().catch(null),
    email: z.string().nullable().catch(null),
    profile_picture_url: z.string().nullable().catch(null),
});

export type PublicProfile = z.infer<typeof publicProfileSchema>;
